module.exports = __webpack_public_path__ + "img/banner-line_big-short.e29ba070.png";